module.exports = __webpack_public_path__ + "img/neweco.6bbd7592.png";